import React from 'react';

function ChildComponent({ content }) {
    return <>{content}</>;
}

export default ChildComponent;
